import React from 'react';
import {Link} from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPhone,FiMail,FiMapPin}=FiIcons;

function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="md:col-span-2">
            <div className="mb-4">
              <Link to="/" className="flex items-center space-x-3">
                <img
                  src="https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1757818262760-Untitled%20design%20%282%29.png"
                  alt="AllGrowth"
                  className="h-8 w-auto"
                />
                <div className="flex flex-col">
                  <span className="text-2xl font-bold text-white">AllGrowth</span>
                  <span className="text-xs text-gray-400">by Handvantage</span>
                </div>
              </Link>
            </div>
            <p className="text-gray-300 mb-6 max-w-md">
              AllGrowth by Handvantage helps local businesses grow with AI-powered content marketing that builds trust,drives traffic,and converts visitors into customers.
            </p>
            <div className="space-y-2">
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiPhone} className="h-4 w-4 text-blue-400" />
                <a
                  href="tel:+12362350919"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  +1 (236) 235-0919
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMail} className="h-4 w-4 text-blue-400" />
                <a
                  href="mailto:info@handvantage.com"
                  className="text-gray-300 hover:text-white transition-colors"
                >
                  info@handvantage.com
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <SafeIcon icon={FiMapPin} className="h-4 w-4 text-blue-400" />
                <span className="text-gray-300">North America and Africa</span>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">AllGrowth Services</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-300 hover:text-white transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-300 hover:text-white transition-colors">
                  Content Marketing
                </Link>
              </li>
              <li>
                <Link to="/digital-transformation-consulting" className="text-gray-300 hover:text-white transition-colors">
                  Digital Transformation
                </Link>
              </li>
              <li>
                <Link to="/business-training-certification" className="text-gray-300 hover:text-white transition-colors">
                  Business Training
                </Link>
              </li>
              <li>
                <Link to="/no-code-development" className="text-gray-300 hover:text-white transition-colors">
                  No-Code Development
                </Link>
              </li>
              <li>
                <Link to="/engagement-growth-engine" className="text-gray-300 hover:text-white transition-colors">
                  Engagement Growth Engine
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Popular Services */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Popular Solutions</h3>
            <ul className="space-y-2">
              <li>
                <span className="text-gray-300">AI Blog Content</span>
              </li>
              <li>
                <span className="text-gray-300">Email Marketing</span>
              </li>
              <li>
                <span className="text-gray-300">Social Media</span>
              </li>
              <li>
                <span className="text-gray-300">Local SEO</span>
              </li>
              <li>
                <span className="text-gray-300">Lead Magnets</span>
              </li>
              <li>
                <span className="text-gray-300">Business Automation</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-center md:text-left">
              © 2025 AllGrowth by Handvantage Corporation. All rights reserved.
            </p>
            <div className="mt-4 md:mt-0">
              <p className="text-gray-500 text-sm text-center md:text-right">
                Powered by <span className="text-gray-300 font-semibold">Handvantage</span> - Enterprise Growth Solutions
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;